import {DomainObject} from 'shared/store';
import { observable, action, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';
import ExpensePolicyApprover from './ExpensePolicyApprover';
import _ from 'lodash';

class ExpensePolicy extends DomainObject {
  id;
  name;
  employees;
  approvers = [];

  _relations = {
    employees: [Employee],
    approvers: [ExpensePolicyApprover]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      employees: observable,
      approvers: observable,
      addApprover: action,
      removeApprover: action,
      setEmployees: action
    });

    this.merge(other);
  }

  addApprover(approver) {
    this.approvers.push(approver);
  }

  removeApprover(approver) {
    this.approvers = _.reject(this.approvers, {value: approver.value});
  }

  setEmployees(employees) {
    this.employees.replace(employees);
  }
}

export default ExpensePolicy;
